import React from "react";
import PropTypes from "prop-types";
import "./Button.css";

const Button = ({
  value,
  children,
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  disabled = false,
  type = "button",
  ...props
}) => {
  // Combine size and variant classes
  const sizeClass = `btn-${size}`;
  const variantClass = `btn-${variant}`;
  const combinedClasses = `app-button ${sizeClass} ${variantClass} ${className}`.trim();

  return (
    <button
      type={type}
      className={combinedClasses}
      onClick={(e) => onClick && onClick(e)}
      disabled={disabled}
      {...props}
    >
      {children || value}
    </button>
  );
};

Button.propTypes = {
  value: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(["primary", "secondary", "success", "danger", "outline", "ghost"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default Button;